import { newModalFromString } from '../components/modal';

function formatDate (date) {
    const $jsDatepicker = $('.js-datepicker');
    if (!($jsDatepicker.data('different-format')) && $jsDatepicker.length > 0) {
        return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
        date.getFullYear();
    } else {
        return ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + '-' +
        date.getFullYear();
    }
}

const formatDateToDDmmYYYY = (date) => {
    return ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + date.getFullYear();
};

function init () {
    let firstDate = new Date();
    let year = firstDate.getFullYear();
    let month = firstDate.getMonth();
    let day = firstDate.getDate();
    let expiryDate = new Date(year + 3, month, day);

    if ($('#dp1').val() !== '') {
        let formattedDate = $('#dp1').val();
        $('.js-giftCardDateExpiryStamp').html(formattedDate);
        $('.datepickerTriggerElement').data('date', formattedDate);
    } else {
        let formattedDate = formatDate(firstDate);
        let formattedExpiryDate = formatDate(expiryDate);
        $('.js-giftCardDateExpiryStamp').html(formattedExpiryDate);
        $('.datepickerTriggerElement').data('date', formatDateToDDmmYYYY(firstDate));
        $('#dp1').val(formattedDate);
    }

    let container = $('.quickview-data');
    var selectedImageIndex = 0;
    if (container.length > 0) {
        selectedImageIndex = parseInt(container.data('selected-image'));
    }

    // Start Validator
    let items = $('.parsleyValidatableElement');
    for (let i = 0; i < items.length; i++) {
        items.eq(i).parsley();
    }

    $('.js-sliderFor').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.js-sliderNav'
    });
    $('.js-sliderNav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.js-sliderFor',
        dots: false,
        focusOnSelect: true,
        accessibility: false,
        centerMode: false,
        speed: 0,
        responsive: [{
            breakpoint: 480,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                autoplay: false
            }
        }]
    });

    $('.js-sliderNav').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $(this).find('.slick-track').css('transform', 'none');
    });

    $('.js-sliderNav').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(this).find('.slick-track').css('transform', 'none');
    });

    $('.js-sliderFor').slick('slickGoTo', selectedImageIndex, true);

    // PRICE
    $('.js-sliderForPrice').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinte: false,
        arrows: false,
        focusOnSelect: false,
        accessibility: false,
        draggable: false
    });

    $('.js-sliderNavPrice .slick-slide').on('click', function (e) {
        e.preventDefault();
        $('.wrapperCarouselPrice').removeClass('invisible');
        $('.slick-current').removeClass('border-off');
    });

    $('body').on('click', '.js-amount-selector', (e) => {
        $('.js-amount-selector').removeClass('active');
        $('.giftCardCarouselPriceContainer').removeClass('hidden');
        $('.js-price-validation-error-not-selected').addClass('hidden');
        $('.js-typeAmount').removeClass('is-invalid-input');

        const $button = $(e.currentTarget);

        if (!$button.hasClass('js-typeAmount')) {
            $('.js-price-validation-error').hide();
            $('.js-typeAmount').removeClass('is-invalid-input');
        }

        let idx = $button.data('idx');
        $('.js-sliderForPrice').slick('slickGoTo', idx, true);
        let amount = $button.attr('data-amount');
        if (parseInt(amount) !== 0 && amount !== null) {
            $('.js-sliderForPriceStamp').text($button.attr('data-amount') + ' ' + document.getElementById('currencySymbol').value);
        }
        $button.addClass('active');
    });

    $('.datepickerTriggerElement').fdatepicker({
        format: 'dd-mm-yyyy',
        disableDblClickSelection: true,
        leftArrow: '<<',
        rightArrow: '>>',
        closeIcon: 'X',
        closeButton: false,
        initialDate: new Date(),
        startDate: new Date()
    }).on('changeDate', function (ev) {
        let date = new Date(ev.date.valueOf() + ev.date.getTimezoneOffset() * 60000);
        var datestring = formatDate(date);
        $('#dp1').val(datestring);
        $('.datepickerTriggerElement').data('date', formatDateToDDmmYYYY(date));

        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        let expiry = new Date(year + 3, month, day);
        $('.js-giftCardDateExpiryStamp').html(formatDate(expiry));
    });

    // Modal Preview gift Card
    $('.js-linkModalGiftCard').on('click', function (e) {
        e.preventDefault();
        const htmlContent = $($(this).data('target')).html();
        // create and open confirmation modal
        const modalBigContent = newModalFromString(htmlContent, false);
        modalBigContent.open();
        modalBigContent.setContent(document.querySelector('.js-ModalGiftCard').innerHTML);
        $('.tingle-modal').addClass('wrapperModalGiftCard');
        $(modalBigContent.modalBox)
            .find('.close')
            .on('click', function (e) {
                modalBigContent.close();
            });

        $('.js-inside-close-modal').on('click', function (e) {
            e.preventDefault();
            modalBigContent.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modalBigContent.close();
        });
    });

    //  PRICE, NAME, TO, PRICE, MESSAGE CUSTOM
    $('.js-giftcardNameTo').keyup(function (e) {
        e.preventDefault();
        const value = $(this).val();
        $('.js-giftcardNameToStamp').text(value);
    });
    $('.js-giftcardYourName').keyup(function (e) {
        e.preventDefault();
        const value = $(this).val();
        $('.js-giftcardYourNameStamp').text(value);
    });
    $('.js-contactFormMessage').keyup(function (e) {
        e.preventDefault();
        const value = $(this).val();
        $('.js-contactFormMessageStamp').text(value);
    });
    $('.js-sliderNav .js-ImgGiftCard').click(function (e) {
        e.preventDefault();
        const value = $(this).html();
        $('.js-ImgGiftCardStamp').html(value);
    });
    $('.js-sliderNavPrice .js-StampPriceGiftCard').click(function (e) {
        e.preventDefault();
        const value = $(this).html();
        $('.js-sliderForPriceStamp').text(value);
    });
    $('.js-typeAmount').on('input', function (e) {
        e.preventDefault();
        const value = $(this).val();
        if (value.length > 0) {
            $('.js-price-validation-error').hide();
            $('.js-typeAmount').removeClass('is-invalid-input');
            if (!value || /[^0-9]/.test(value)) {
                $('.js-price-validation-error').show();
                $('.js-typeAmount').addClass('is-invalid-input');
                $('.js-price-manual .price').text('--');
                $('.js-typeAmount').attr('data-amount', 0);
                return;
            }
            let parsedValue = parseInt(value, 10);
            let minimumValue = parseInt($('.js-typeAmount').data('min'), 10);
            let maximumValue = parseInt($('.js-typeAmount').data('max'), 10);
            if (parsedValue < minimumValue || parsedValue > maximumValue) {
                $('.js-price-validation-error').show();
                $('.js-typeAmount').addClass('is-invalid-input');
                $('.js-price-manual .price').text('--');
                $('.js-sliderForPriceStamp').text('--');
                $('.js-typeAmount').attr('data-amount', 0);
                return;
            }

            let valueStr = value + ' ' + document.getElementById('currencySymbol').value;
            $('.js-price-manual .price').text(valueStr);
            $('.js-sliderForPriceStamp').text(valueStr);
            $('.js-typeAmount').attr('data-amount', value);
            $('.js-price-manual').show();
        } else {
            $('.js-sliderForPriceStamp').text('--');
            $('.js-price-manual .price').text('--');
        }
    });

    var maxLength = 230;
    $('.js-contactFormMessage').keyup(function (e) {
        e.preventDefault();
        const textlen = maxLength - $(this).val().length;
        $('#egcMessageFeedbackNumber').text(textlen);
    }).keyup();
};

export default init;
